import { auxiliaryPaneTelemetryTracker, widgetElement } from "@/app/utils/Utils";
import { SERVICE } from "@agentx/agentx-services";
export const telemetryTracker = (tabName) => {
    switch (tabName) {
        case widgetElement.CONTACT_HISTORY:
            auxiliaryPaneTelemetryTracker(widgetElement.CONTACT_HISTORY);
            SERVICE.telemetry.setValueInCache(SERVICE.telemetry.TELEM_CACHE_KEYS.AUXILIARY_PANEL_TAB_NAME, widgetElement.CONTACT_HISTORY);
            SERVICE.telemetry.setValueInCache(SERVICE.telemetry.TELEM_CACHE_KEYS.CONTACT_HISTORY_START_TIME, new Date().getTime());
            break;
        case widgetElement.WXM_JOURNEY:
            auxiliaryPaneTelemetryTracker(widgetElement.WXM_JOURNEY);
            SERVICE.telemetry.setValueInCache(SERVICE.telemetry.TELEM_CACHE_KEYS.AUXILIARY_PANEL_TAB_NAME, widgetElement.WXM_JOURNEY);
            SERVICE.telemetry.setValueInCache(SERVICE.telemetry.TELEM_CACHE_KEYS.WXM_JOURNEY_START_TIME, new Date().getTime());
            break;
    }
};
